import React from 'react';

import { Link, useLocation } from 'react-router-dom';
import { projectList } from '../../service/data/projectList';
import '../../assets/scss/project/nextProjectButton.scss'
import ProjectItem from '../../models/ProjectItem';

function NextProjectButton() {
    let location = useLocation();
    const currentUrl = /[a-z]+/.exec(location.pathname);
    const isCurrentLoc = (loc: ProjectItem) => loc.url === currentUrl![0];
    const index: number = projectList.findIndex(isCurrentLoc);

    const previous = () => {
        if (index - 1 >= 0) {
            return (
                <Link to={`/${projectList[index - 1].url}`} className="f-left next-project"  >Previous</Link>
            )
        }
    }
    const next = () => {
        if (index + 1 <= projectList.length) {
            return (
                <Link to={`/${projectList[index + 1].url}`} className="f-right next-project" >Next</Link>
            )
        }
    }

    return (

        <div className="next-button">
            {index === 0 ? null : previous()}
            {index === projectList.length - 1 ? null : next()}
        </div>
    );
}

export default NextProjectButton;